export enum LocalStorageKeys {
    token = "token",
    lang = "lang",
    country = "country",
    last_event_time = "last_event_time",
    company_date = "company_date",
    company_settings = "company_settings"
}